<div class="stack" [ngStyle]="{ gap: spacing + 'px' }">
  <ng-content></ng-content>
</div>
